import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { NewProjectFormComponent } from './new-project-form/new-project-form.component';

@Component({
  selector: 'app-new-project-idea',
  standalone: true,
  imports: [NewProjectFormComponent, TranslateModule, RouterLink],
  templateUrl: './new-project-idea.component.html',
  styleUrl: './new-project-idea.component.scss',
})
export class NewProjectIdeaComponent {}
